import { format, toDate } from "date-fns";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { getLocale } from "../../../../utils/redux/date";
import { SectionBlock, Text } from "../../talent.styled";
import { BulletTitle, TitleAbout } from "../about/about.styled";
import ProExp from "../../../../models/professional-experience.model";
import TranslatedText from "../../../translated-text/translated-text";

interface ProfessionalExperienceProps {
  professionalExperiences?: ProExp[];
}

const ProfessionalExperience: React.FC<ProfessionalExperienceProps> = ({
  professionalExperiences,
}) => {
  const { t, i18n } = useTranslation("private-home-page");

  const getInterval = useCallback(
    (pro_exp: ProExp) => {
      const FORMAT = "MMMM yyyy";
      const LOCALE_OBJECT = { locale: getLocale(i18n.language) };

      const start_date = toDate(Date.parse(pro_exp.start_date));
      const exit_date = pro_exp.exit_date
        ? toDate(Date.parse(pro_exp.exit_date))
        : null;

      return `${format(start_date, FORMAT, LOCALE_OBJECT)} - ${
        exit_date
          ? format(exit_date, FORMAT, LOCALE_OBJECT)
          : t("talent.currentJob")
      }`;
    },
    [t, i18n.language]
  );

  return (
    <SectionBlock>
      <TitleAbout>{t("talent.professionalExperiences")}</TitleAbout>
      {professionalExperiences?.map((exp) => (
        <div key={exp.id}>
          <BulletTitle>{exp.company}</BulletTitle>
          <Text>
            <strong>
              <TranslatedText color={"#858b8d"}>{exp.office}</TranslatedText> (
              {getInterval(exp)})
            </strong>
          </Text>
          <TranslatedText
            color={"#858b8d"}
            fontSize={"14"}
            lineHeight={"24"}
            margin={"0.75rem 0px 0.625rem"}
          >
            {exp.description}
          </TranslatedText>
        </div>
      ))}
    </SectionBlock>
  );
};

export default ProfessionalExperience;
